<template>
  <TrustpilotWrapper
    :widget-id="TRUSTPILOT_MICRO_BUTTON_ID"
    :show-widget="showWidget"
    :trustpilot-height="TRUSTPILOT_MICRO_BUTTON_WIDGET_HEIGHT"
  />
</template>

<script lang="ts">
import { TRUSTPILOT_MICRO_BUTTON_ID } from '~~/constants/trustPilot';
import { TRUSTPILOT_MICRO_BUTTON_WIDGET_HEIGHT } from '~~/constants/ui';

export default defineComponent({
  name: 'TrustpilotMicroButton',

  props: {
    showWidget: {
      type: Boolean,
      default: true,
    },
  },
  setup () {

    return {
      TRUSTPILOT_MICRO_BUTTON_ID,
      TRUSTPILOT_MICRO_BUTTON_WIDGET_HEIGHT,
    };
  
  },
});


</script>
